var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('Tabs',{attrs:{"type":"card"},on:{"on-click":_vm.handleTab},model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},_vm._l((_vm.tabList),function(item){return _c('TabPane',{key:item.type,attrs:{"label":item.name,"name":item.type}})}),1)]},proxy:true},{key:"cost",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('CostPage',{attrs:{"rows":params,"close":close}}):_vm._e()]}},{key:"DETAILS",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Double',{attrs:{"awbno":params.row.airway_number}}):_vm._e(),_c('audio',{ref:"audio",staticStyle:{"display":"none"},attrs:{"preload":""}},[_c('source',{attrs:{"src":_vm.audiosrc}})])]}},{key:"STATUS",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Tracker',{attrs:{"statusId":params.row.airway_number}}):_vm._e()]}},{key:"ADJUST",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Adjust',{attrs:{"awbno":params.airway_number}}):_vm._e()]}},{key:"UNPACK",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Unpack',{attrs:{"itemId":params.row.id,"statusId":params.row.airway_number}}):_vm._e()]}},{key:"INFO",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('DoubleInfo',{attrs:{"row":params.row,"close":close}}):_vm._e()]}},{key:"FREIGHT",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('DoubleBill',{ref:"FREIGHT",attrs:{"row":params.row,"close":close}}):_vm._e()]}},{key:"INBOUND",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('B2bInbound',{ref:"inbound",attrs:{"billId":params.row.airway_number}}):_vm._e()]}},{key:"OUT",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Outbound',{attrs:{"billId":params.row.airway_number}}):_vm._e()]}},{key:"PACK",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Pack',{attrs:{"billId":params.row.airway_number}}):_vm._e()]}},{key:"UPLOAD",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
var close = ref.close;
return [(visible)?_c('UploadFile',{attrs:{"url":params.url,"uploadFunction":params.requestApi,"close":close,"resTable":params.resTable}}):_vm._e()]}},{key:"datails",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Details',{attrs:{"billId":params.row.airway_number}}):_vm._e()]}},{key:"branchFright",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('BranchFeright',{ref:"branchFeright",attrs:{"row":params,"close":close}}):_vm._e()]}},{key:"AwsFist",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [_c('img',{attrs:{"src":require("@/assets/images/aws.png")}}),_c('div',{staticClass:"show-process"},[(typeof params.row !== 'undefined')?_vm._l((params.row.fistData),function(item,key){return _c('div',{key:'Fist' + key,staticClass:"process-item"},[_c('div',{staticClass:"process-date"},[_vm._v(_vm._s(item.date))]),_c('div',{staticClass:"process-time"},[_vm._v(_vm._s(item.time))])])}):_vm._e()],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }